<template>
  <div>
    <div class="button-bar">
      <div class="items1">
        <WDStepTitle
          :propsMode="propsMode"
          :quoteType="quoteType"
          :quoteId="quoteId"
          :status="vehicle.status"
        />
      </div>
      <div class="items2">
        <div>
          <button
            v-if="propsData.status == 1"
            class="btn btn-success btn-sm"
            data-toggle="tooltip"
            data-placement="top"
            title="Save quote"
            @click="fnSaveApplication((isSave = true))"
          >
            <i class="lar la-save"></i>Save
          </button>
        </div>
        <div v-if="fnIsShowUnlockButton()">
          <appModalUnlockMessage
            :propsData="propsData"
            v-if="getIsLock == true"
          ></appModalUnlockMessage>

          <button
            v-if="getIsLock != true"
            class="btn btn-success btn-sm"
            data-toggle="tooltip"
            data-placement="top"
            title="Save quote"
            @click="fnSaveApplication((isSave = true))"
          >
            <i class="lar la-save"></i>Save
          </button>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 col-md-6 col-lg-6 col-xl-3">
        <!-- Personal details -->
        <div class="mb-3">
          <h5 class="text-info mb-0">
            Client Details {{ getQuoteErrors['client.*'] }}
          </h5>
        </div>
        <div class="form-group">
          <b-form-select
            plain
            autocomplete="off_title"
            placeholder=" "
            :options="optionTitle"
            v-model="client.title"
            @input="fnTitleChange()"
          ></b-form-select>
          <label class="floatingLabel" for="title">Title</label>
        </div>

        <div class="form-group sitsRadioGroup m-t400">
          <label for="gender" class="">Gender</label>
          <b-form-radio-group
            id="off_gender"
            name="off_gender"
            class="m-t400"
            autocomplete="off_gender"
            :options="optionGender"
            value-field="value"
            text-field="text"
            v-model="client.gender"
          ></b-form-radio-group>
          <div class="invalid-feedback" v-if="getQuoteErrors['client.gender']">
            {{ fnReplace(getQuoteErrors['client.gender']) }}
          </div>
        </div>

        <div class="form-group">
          <input
            type="text"
            class="form-control"
            autocomplete="off_firstName"
            placeholder=" "
            id="firstName"
            v-model="client.firstName"
          />
          <label class="floatingLabel" for="firstName">First Name</label>
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['client.firstName']"
          >
            {{ fnReplace(getQuoteErrors['client.firstName']) }}
          </div>
        </div>
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            autocomplete="off_middleName"
            placeholder=" "
            id="middleName"
            v-model="client.middleName"
          />
          <label class="floatingLabel" for="middleName">Middle Name</label>
        </div>
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            autocomplete="off_lastName"
            placeholder=" "
            id="lastName"
            v-model="client.lastName"
          />
          <label class="floatingLabel" for="lastName">Surname</label>
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['client.lastName']"
          >
            {{ fnReplace(getQuoteErrors['client.lastName']) }}
          </div>
        </div>
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            autocomplete="off_mobileNumber"
            id="mobileNumber"
            placeholder=" "
            v-model="client.mobileNumber"
          />
          <label class="floatingLabel" for="mobileNumber">Mobile Number</label>
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['client.mobileNumber']"
          >
            {{ fnReplace(getQuoteErrors['client.mobileNumber']) }}
          </div>
        </div>
        <div class="form-group">
          <input
            type="email"
            class="form-control"
            autocomplete="off_email"
            id="Email"
            placeholder=" "
            v-model="client.email"
          />
          <label class="floatingLabel" for="email">Email</label>
          <div class="invalid-feedback" v-if="getQuoteErrors['client.email']">
            {{ fnReplace(getQuoteErrors['client.email']) }}
          </div>
        </div>
        <div class="form-group">
          <b-form-input
            id="dateOfBirth"
            type="date"
            autocomplete="off_dateOfBirth"
            placeholder=" "
            v-model="client.dateOfBirth"
          >
          </b-form-input>
          <label class="floatingLabel" for="dateOfBirth">Date of Birth</label>
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['client.dateOfBirth']"
          >
            {{ fnReplace(getQuoteErrors['client.dateOfBirth']) }}
          </div>
        </div>
        <div class="form-group sitsRadioGroup m-t400">
          <label for="anotherNameYesNo" class=""
            >Have you been known by another name?</label
          >
          <b-form-radio-group
            class="m-t400"
            autocomplete="off_anotherNameYesNo"
            placeholder=" "
            id="anotherNameYesNo"
            name="anotherNameYesNo"
            :options="anotherNameOptionYesNo"
            value-field="value"
            text-field="text"
            v-model="client.anotherNameYesNo"
          ></b-form-radio-group>
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['anotherNameOptionYesNo']"
          >
            {{ fnReplace(getQuoteErrors['anotherNameOptionYesNo']) }}
          </div>
        </div>

        <!-- Other name -->
        <div class="" v-if="client.anotherNameYesNo == 'Yes'">
          <div class="">
            <p class="mb-0">Other name</p>
            <hr class="mt100 secondaryHr" />
          </div>
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              autocomplete="off_otherFirstName"
              placeholder=" "
              id="otherFirstName"
              v-model="client.otherFirstName"
            />
            <label class="floatingLabel" for="otherFirstName">First Name</label>
            <div
              class="invalid-feedback"
              v-if="getQuoteErrors['client.otherFirstName']"
            >
              {{ fnReplace(getQuoteErrors['client.otherFirstName']) }}
            </div>
          </div>
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              autocomplete="off_otherMiddleName"
              placeholder=" "
              id="otherMiddleName"
              v-model="client.otherMiddleName"
            />
            <label class="floatingLabel" for="otherMiddleName"
              >Middle Name</label
            >
          </div>
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              autocomplete="off_otherLastName"
              placeholder=" "
              id="otherLastName"
              v-model="client.otherLastName"
            />
            <label class="floatingLabel" for="otherLastName">Surname</label>
            <div
              class="invalid-feedback"
              v-if="getQuoteErrors['client.otherLastName']"
            >
              {{ fnReplace(getQuoteErrors['client.otherLastName']) }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-6 col-xl-3">
        <!-- Drivers licence -->
        <div class="mb-3">
          <h5 class="text-info mb-0">Drivers License Details</h5>
        </div>
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            autocomplete="off_driversLicenceNumber"
            placeholder=" "
            id="driversLicenceNumber"
            v-model="client.driversLicenceNumber"
          />
          <label class="floatingLabel" for="redidentialStatus">Number</label>
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['client.driversLicenceNumber']"
          >
            {{ fnReplace(getQuoteErrors['client.driversLicenceNumber']) }}
          </div>
        </div>
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            autocomplete="off_driversLicenceCardNumber"
            placeholder=" "
            id="driversLicenceCardNumber"
            v-model="client.driversLicenceCardNumber"
          />
          <label class="floatingLabel" for="driversLicenceCardNumber"
            >Card Number</label
          >
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['client.driversLicenceCardNumber']"
          >
            {{ fnReplace(getQuoteErrors['client.driversLicenceCardNumber']) }}
          </div>
        </div>
        <div class="form-group">
          <b-form-input
            id="driversLicenceExpiryDate"
            type="date"
            autocomplete="off_driversLicenceExpiryDate"
            placeholder=" "
            v-model="client.driversLicenceExpiryDate"
          >
          </b-form-input>
          <label class="floatingLabel" for="driversLicenceExpiryDate"
            >Expiry Date(YYYY-MM-DD)</label
          >
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['client.driversLicenceExpiryDate']"
          >
            {{ fnReplace(getQuoteErrors['client.driversLicenceExpiryDate']) }}
          </div>
        </div>
        <div class="form-group">
          <b-form-select
            plain
            autocomplete="off_driversLicenceState"
            placeholder=" "
            :options="getSettingAll.state"
            value-field="code"
            text-field="code"
            v-model="client.driversLicenceState"
          ></b-form-select>
          <label class="floatingLabel" for="driversLicenceState">State</label>
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['client.driversLicenceState']"
          >
            {{ fnReplace(getQuoteErrors['client.driversLicenceState']) }}
          </div>
        </div>
        <div class="form-group">
          <b-form-select
            plain
            autocomplete="off_driversLicenceType"
            placeholder=" "
            :options="getSettingAll.driversLicenceType"
            value-field="name"
            text-field="name"
            v-model="client.driversLicenceType"
          ></b-form-select>
          <label class="floatingLabel" for="driversLicenceType">Type</label>
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['client.driversLicenceType']"
          >
            {{ fnReplace(getQuoteErrors['client.driversLicenceType']) }}
          </div>
        </div>

        <!-- Marital status & Number of dependants -->
        <div class="">
          <div class="">
            <p class="mb-0 text-dark-light">Marital Status</p>
            <hr class="mt100 secondaryHr" />
          </div>

          <div class="form-group sitsRadioGroup">
            <b-form-radio-group
              id="off_maritalStatus"
              name="off_maritalStatus"
              class="m-t400"
              autocomplete="off_maritalStatus"
              placeholder=" "
              :options="optionMaritalStatus"
              value-field="value"
              text-field="text"
              v-model="client.maritalStatus"
            ></b-form-radio-group>
            <div
              class="invalid-feedback"
              v-if="getQuoteErrors['client.maritalStatus']"
            >
              {{ fnReplace(getQuoteErrors['client.maritalStatus']) }}
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <p class="mb-0">Partner's</p>
              <hr class="mt100 secondaryHr" />
            </div>
            <div
              class="col-lg-6 col-md-6 col-12"
              v-if="client.maritalStatus != 'Single'"
            >
              <div class="form-group">
                <input
                  type="number"
                  step="any"
                  class="form-control"
                  autocomplete="off_partnerAnnualGrossSalary"
                  placeholder=" "
                  id="partnerAnnualGrossSalary"
                  v-model="client.partnerAnnualGrossSalary"
                />
                <label class="floatingLabel" for="partnerAnnualGrossSalary"
                  >Annual Gross Salary</label
                >
                <div
                  class="invalid-feedback"
                  v-if="getQuoteErrors['client.partnerAnnualGrossSalary']"
                >
                  {{
                    fnReplace(getQuoteErrors['client.partnerAnnualGrossSalary'])
                  }}
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-12">
              <div class="form-group">
                <input
                  type="number"
                  class="form-control"
                  autocomplete="off_numberOfDependents"
                  placeholder=" "
                  id="numberOfDependents"
                  v-model="client.numberOfDependents"
                />
                <label class="floatingLabel" for="numberOfDependents"
                  >Number of Dependents</label
                >
                <div
                  class="invalid-feedback"
                  v-if="getQuoteErrors['client.numberOfDependents']"
                >
                  {{ fnReplace(getQuoteErrors['client.numberOfDependents']) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-12 col-lg-12 col-xl-6">
        <!-- Personal details -->

        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <h5 class="text-info mb-0">Address Details</h5>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-2 col-md-2 col-12">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                autocomplete="off_hAddressUnitNumber"
                placeholder=" "
                id="hAddressUnitNumber"
                v-model="client.hAddressUnitNumber"
              />
              <label class="floatingLabel" for="hAddressUnitNumber"
                >Unit No</label
              >
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-12">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                autocomplete="off_hAddressStreetNumber"
                placeholder=" "
                id="hAddressStreetNumber"
                v-model="client.hAddressStreetNumber"
              />
              <label class="floatingLabel" for="hAddressStreetNumber"
                >Street No</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['client.hAddressStreetNumber']"
              >
                {{ fnReplace(getQuoteErrors['client.hAddressStreetNumber']) }}
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12">
            <div class="form-group">
              <input
                type="Name"
                class="form-control"
                autocomplete="off_hAddressStreetName"
                placeholder=" "
                id="hAddressStreetName"
                v-model="client.hAddressStreetName"
              />
              <label class="floatingLabel" for="hAddressStreetName"
                >Street Name</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['client.hAddressStreetName']"
              >
                {{ fnReplace(getQuoteErrors['client.hAddressStreetName']) }}
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-4 col-12">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                autocomplete="off_hAddressSuburb"
                placeholder=" "
                id="hAddressSuburb"
                v-model="client.hAddressSuburb"
              />
              <label class="floatingLabel" for="hAddressSuburb">Suburb</label>
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['client.hAddressSuburb']"
              >
                {{ fnReplace(getQuoteErrors['client.hAddressSuburb']) }}
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12">
            <div class="form-group">
              <b-form-select
                plain
                autocomplete="off_hAddressState"
                placeholder=" "
                :options="getSettingAll.state"
                value-field="code"
                text-field="code"
                v-model="client.hAddressState"
              ></b-form-select>
              <label class="floatingLabel" for="hAddressState">State</label>
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['client.hAddressState']"
              >
                {{ fnReplace(getQuoteErrors['client.hAddressState']) }}
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12">
            <div class="form-group">
              <input
                type="number"
                class="form-control"
                autocomplete="off_hAddressPostcode"
                placeholder=" "
                id="hAddressPostcode"
                v-model="client.hAddressPostcode"
              />
              <label class="floatingLabel" for="hAddressSuburb">Postcode</label>
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['client.hAddressPostcode']"
              >
                {{ fnReplace(getQuoteErrors['client.hAddressPostcode']) }}
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12">
            <div class="form-group">
              <b-form-select
                plain
                autocomplete="off_hAddressCountry"
                placeholder=" "
                :options="getSettingAll.country"
                value-field="name"
                text-field="name"
                v-model="client.hAddressCountry"
              ></b-form-select>
              <label class="floatingLabel" for="hAddressCountry">Country</label>
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['client.hAddressCountry']"
              >
                {{ fnReplace(getQuoteErrors['client.hAddressCountry']) }}
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-12">
            <div class="form-group">
              <input
                type="number"
                class="form-control"
                autocomplete="off_hAddressTimeAtYears"
                placeholder=" "
                id="hAddressTimeAtYears"
                min="0"
                v-model="client.hAddressTimeAtYears"
              />
              <label class="floatingLabel" for="hAddressTimeAtYears"
                >Time at (Years)</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['client.hAddressTimeAtYears']"
              >
                {{ fnReplace(getQuoteErrors['client.hAddressTimeAtYears']) }}
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-12">
            <div class="form-group">
              <input
                type="number"
                class="form-control"
                autocomplete="off_hAddressTimeAtYears"
                placeholder=" "
                id="hAddressTimeAtMonths"
                min="0"
                max="12"
                v-model="client.hAddressTimeAtMonths"
              />
              <label class="floatingLabel" for="hAddressTimeAtMonths"
                >Time at (Months)</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['client.hAddressTimeAtMonths']"
              >
                {{ fnReplace(getQuoteErrors['client.hAddressTimeAtMonths']) }}
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-12">
            <div class="form-group">
              <b-form-select
                plain
                autocomplete="off_hAddressResidenceStatus"
                placeholder=" "
                :options="getSettingAll.residenceStatus"
                value-field="name"
                text-field="name"
                v-model="client.hAddressResidenceStatus"
              ></b-form-select>
              <label class="floatingLabel" for="hAddressResidenceStatus"
                >Residence Status</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['client.hAddressResidenceStatus']"
              >
                {{
                  fnReplace(getQuoteErrors['client.hAddressResidenceStatus'])
                }}
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-12">
            <div
              class="form-group"
              v-if="client.hAddressResidenceStatus == 'Renting'"
            >
              <input
                type="number"
                class="form-control"
                autocomplete="off_hAddressMonthlyRentalAmount"
                placeholder=" "
                id="hAddressMonthlyRentalAmount"
                min="0"
                max="12"
                v-model="client.hAddressMonthlyRentalAmount"
              />
              <label class="floatingLabel" for="hAddressMonthlyRentalAmount"
                >Mon. Rental Amount</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['client.hAddressMonthlyRentalAmount']"
              >
                {{
                  fnReplace(
                    getQuoteErrors['client.hAddressMonthlyRentalAmount']
                  )
                }}
              </div>
            </div>
          </div>
        </div>

        <!-- Previous home address -->
        <div
          class="row"
          v-if="fnChecklessThan3Years >= 0 && fnChecklessThan3Years < 36"
        >
          <div class="col-12">
            <p class="mb-0 text-dark-light">Previous Home Address</p>
            <hr class="mt100 secondaryHr" />
          </div>
          <div class="col-lg-2 col-md-2 col-12">
            <div class="form-group">
              <input
                type="number"
                class="form-control"
                autocomplete="off_pHAddressUnitNumber"
                placeholder=" "
                id="pHAddressUnitNumber"
                v-model="client.pHAddressUnitNumber"
              />
              <label class="floatingLabel" for="pHAddressUnitNumber"
                >Unit No</label
              >
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-12">
            <div class="form-group">
              <input
                type="number"
                class="form-control"
                autocomplete="off_pHAddressStreetNumber"
                placeholder=" "
                id="pHAddressStreetNumber"
                v-model="client.pHAddressStreetNumber"
              />
              <label class="floatingLabel" for="pHAddressStreetNumber"
                >Street No</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['client.pHAddressStreetNumber']"
              >
                {{ fnReplace(getQuoteErrors['client.pHAddressStreetNumber']) }}
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12">
            <div class="form-group">
              <input
                type="Name"
                class="form-control"
                autocomplete="off_pHAddressStreetName"
                placeholder=" "
                id="pHAddressStreetName"
                v-model="client.pHAddressStreetName"
              />
              <label class="floatingLabel" for="pHAddressStreetName"
                >Street Name</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['client.pHAddressStreetName']"
              >
                {{ fnReplace(getQuoteErrors['client.pHAddressStreetName']) }}
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                autocomplete="off_pHAddressSuburb"
                placeholder=" "
                id="pHAddressSuburb"
                v-model="client.pHAddressSuburb"
              />
              <label class="floatingLabel" for="pHAddressSuburb">Suburb</label>
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['client.pHAddressSuburb']"
              >
                {{ fnReplace(getQuoteErrors['client.pHAddressSuburb']) }}
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12">
            <div class="form-group">
              <b-form-select
                plain
                autocomplete="off_pHAddressState"
                placeholder=" "
                :options="getSettingAll.state"
                value-field="code"
                text-field="code"
                v-model="client.pHAddressState"
              ></b-form-select>
              <label class="floatingLabel" for="pHAddressState">State</label>
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['client.pHAddressState']"
              >
                {{ fnReplace(getQuoteErrors['client.pHAddressState']) }}
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12">
            <div class="form-group">
              <input
                type="number"
                class="form-control"
                autocomplete="off_pHAddressPostcode"
                placeholder=" "
                id="pHAddressPostcode"
                v-model="client.pHAddressPostcode"
              />
              <label class="floatingLabel" for="pHAddressSuburb"
                >Postcode</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['client.pHAddressPostcode']"
              >
                {{ fnReplace(getQuoteErrors['client.pHAddressPostcode']) }}
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12">
            <div class="form-group">
              <b-form-select
                plain
                v-if="getSettingAll.country"
                :options="getSettingAll.country"
                value-field="name"
                text-field="name"
                placeholder=" "
                autocomplete="off_pHAddressCountry"
                v-model="client.pHAddressCountry"
              ></b-form-select>
              <label class="floatingLabel" for="pHAddressCountry"
                >Country</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['client.pHAddressCountry']"
              >
                {{ fnReplace(getQuoteErrors['client.pHAddressCountry']) }}
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-3 col-12">
            <div class="form-group">
              <input
                type="number"
                class="form-control"
                autocomplete="off_pHAddressTimeAtYears"
                placeholder=" "
                id="pHAddresTimeAtYears"
                v-model="client.pHAddressTimeAtYears"
              />
              <label class="floatingLabel" for="pHAddressTimeAtYears"
                >Time at (Years)</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['client.pHAddressTimeAtYears']"
              >
                {{ fnReplace(getQuoteErrors['client.pHAddressTimeAtYears']) }}
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-12">
            <div class="form-group">
              <input
                type="number"
                class="form-control"
                autocomplete="off_pHAddressTimeAtYears"
                placeholder=" "
                id="pHAddressTimeAtMonths"
                v-model="client.pHAddressTimeAtMonths"
              />
              <label class="floatingLabel" for="pHAddressTimeAtMonths"
                >Time at (Months)</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['client.pHAddressTimeAtMonths']"
              >
                {{ fnReplace(getQuoteErrors['client.pHAddressTimeAtMonths']) }}
              </div>
            </div>
          </div>
        </div>

        <!-- Postal address -->
        <div class="row">
          <div class="col-12">
            <div class="form-group sitsRadioGroup m-t400">
              <label for="postalAddressAndHomeAddressAreSameYesNo" class=""
                >Is postal address different from residential?</label
              >
              <b-form-radio-group
                class="m-t400"
                autocomplete="off_postalAddressAndHomeAddressAreSameYesNo"
                placeholder=" "
                id="postalAddressAndHomeAddressAreSameYesNo"
                name="postalAddressAndHomeAddressAreSameYesNo"
                :options="optionPostalAddressAndHomeAddressAreSameYesNo"
                value-field="value"
                text-field="text"
                v-model="client.postalAddressAndHomeAddressAreSameYesNo"
              ></b-form-radio-group>
              <div
                class="invalid-feedback"
                v-if="
                  getQuoteErrors[
                    'client.postalAddressAndHomeAddressAreSameYesNo'
                  ]
                "
              >
                {{
                  fnReplace(
                    getQuoteErrors[
                      'client.postalAddressAndHomeAddressAreSameYesNo'
                    ]
                  )
                }}
              </div>
            </div>
          </div>
        </div>

        <div
          class="row"
          v-if="client.postalAddressAndHomeAddressAreSameYesNo == 'Yes'"
        >
          <div class="col-12">
            <p class="mb-0">Postal Address</p>
            <hr class="mt100 secondaryHr" />
          </div>
          <div class="col-lg-3 col-md-3 col-12">
            <div class="form-group">
              <input
                type="number"
                class="form-control"
                autocomplete="off_postalAddressPOBoxNumber"
                placeholder=" "
                id="postalAddressPOBoxNumber"
                v-model="client.postalAddressPOBoxNumber"
              />
              <label class="floatingLabel" for="postalAddressPOBoxNumber"
                >PO Box Number</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['client.postalAddressPOBoxNumber']"
              >
                {{
                  fnReplace(getQuoteErrors['client.postalAddressPOBoxNumber'])
                }}
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                autocomplete="off_postalAddressSuburb"
                placeholder=" "
                id="postalAddressSuburb"
                v-model="client.postalAddressSuburb"
              />
              <label class="floatingLabel" for="postalAddressSuburb"
                >Suburb</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['client.postalAddressSuburb']"
              >
                {{ fnReplace(getQuoteErrors['client.postalAddressSuburb']) }}
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-12">
            <div class="form-group">
              <b-form-select
                plain
                autocomplete="off_postalAddressState"
                placeholder=" "
                :options="getSettingAll.state"
                value-field="code"
                text-field="code"
                v-model="client.postalAddressState"
              ></b-form-select>
              <label class="floatingLabel" for="postalAddressState"
                >State</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['client.postalAddressState']"
              >
                {{ fnReplace(getQuoteErrors['client.postalAddressState']) }}
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-12">
            <div class="form-group">
              <input
                type="number"
                class="form-control"
                autocomplete="off_postalAddressPostcode"
                placeholder=" "
                id="postalAddressPostcode"
                v-model="client.postalAddressPostcode"
              />
              <label class="floatingLabel" for="postalAddressPostcode"
                >Postcode</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['client.postalAddressPostcode']"
              >
                {{ fnReplace(getQuoteErrors['client.postalAddressPostcode']) }}
              </div>
            </div>
          </div>
        </div>

        <!-- Australian residency -->
        <div class="row">
          <div class="col-12">
            <p class="mb-0 text-dark-light">Australian Residency</p>
            <hr class="mt100 secondaryHr" />
          </div>

          <div class="col-lg-4 col-md-4 col-12">
            <div class="form-group">
              <b-form-select
                plain
                autocomplete="off_australianResidencyStatus"
                placeholder=" "
                :options="getSettingAll.australianResidencyStatus"
                value-field="id"
                text-field="name"
                v-model="client.australianResidencyStatusId"
              ></b-form-select>
              <label class="floatingLabel" for="australianResidencyStatus"
                >Status</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['client.australianResidencyStatusId']"
              >
                {{
                  fnReplace(
                    getQuoteErrors['client.australianResidencyStatusId']
                  )
                }}
              </div>
            </div>
          </div>
          <div
            class="col-lg-4 col-md-4 col-12"
            v-if="client.australianResidencyStatusId == 2"
          >
            <div class="form-group">
              <b-form-select
                plain
                autocomplete="off_visaType"
                placeholder=" "
                :options="getSettingAll.visaType"
                value-field="id"
                text-field="name"
                v-model="client.visaTypeId"
              ></b-form-select>
              <label class="floatingLabel" for="visaType">Visa Type</label>
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['client.visaTypeId']"
              >
                {{ fnReplace(getQuoteErrors['client.visaTypeId']) }}
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12">
            <div class="form-group sitsRadioGroup m-t400">
              <label for="citizenOfAnotherCountryYesNo" class=""
                >Are you a Citizen of Another Country</label
              >
              <b-form-radio-group
                class="m-t400"
                autocomplete="off_citizenOfAnotherCountryYesNo"
                placeholder=" "
                id="citizenOfAnotherCountryYesNo"
                name="citizenOfAnotherCountryYesNo"
                value-field="value"
                text-field="text"
                :options="optionCitizenOfAnotherCountryYesNo"
                v-model="client.citizenOfAnotherCountryYesNo"
              >
              </b-form-radio-group>
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['client.citizenOfAnotherCountryYesNo']"
              >
                {{
                  fnReplace(
                    getQuoteErrors['client.citizenOfAnotherCountryYesNo']
                  )
                }}
              </div>
            </div>
          </div>
          <div
            class="col-lg-4 col-md-4 col-12"
            v-if="client.citizenOfAnotherCountryYesNo == 'Yes'"
          >
            <div class="form-group">
              <b-form-select
                plain
                autocomplete="off_citizenOfAnotherCountry"
                placeholder=" "
                :options="getSettingAll.country"
                value-field="id"
                text-field="name"
                v-model="client.citizenOfAnotherCountry"
              ></b-form-select>
              <label class="floatingLabel" for="citizenOfAnotherCountry"
                >Which Country</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['client.citizenOfAnotherCountry']"
              >
                {{
                  fnReplace(getQuoteErrors['client.citizenOfAnotherCountry'])
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ModalQuoteSubmitConfirm
      ref="modalQuoteSubmitConfirm"
      :propsData="propsData"
      :quoteType="quoteType"
    ></ModalQuoteSubmitConfirm>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import appModalUnlockMessage from '../../components/quote/ModalUnlockMessage.vue'
import WDStepTitle from '../../components/wd/WDStepTitle.vue'
import ModalQuoteSubmitConfirm from '../../components/quote/ModalQuoteSubmitConfirm.vue'
import {
  optionTitle,
  optionGender,
  optionMaritalStatus,
  anotherNameOptionYesNo,
  optionCitizenOfAnotherCountryYesNo,
  optionPostalAddressAndHomeAddressAreSameYesNo
} from '../../services/data.service'

export default {
  name: 'quoteStep2',
  props: ['propsMode', 'propsData', 'quoteType'],
  components: {
    appModalUnlockMessage,
    WDStepTitle,
    ModalQuoteSubmitConfirm
  },
  data() {
    return {
      errors: {},
      quoteId: this.$route.params.quoteId,
      isSave: false,
      step: 2,
      // client_vehicle_details
      vehicle: {
        clientId: '',
        dealerId: '',
        referralPartnerId: '',
        referDealerId: '',
        leadSource: '',
        salaryPackagingProviderId: '',
        salaryPackagingProviderFee: '',
        vehicleCondition: '',
        odometerReading: '',
        year: '',
        make: '',
        model: '',
        variant: '',
        bodyType: '',
        vehicleCategoryId: '',
        fuelFlatRate: '',
        fuelCostPerKM: '',
        tyresCostPerKM: '',
        serviceCostPerKM: '',
        transmissionId: '',
        fuelTypeId: '',
        colour: '',
        accessories: '',
        term: '',
        rvRate: '',
        annualKms: '',
        noFinanceInsurance: '',
        comprehensiveInsurer: '',
        comprehensiveInsurancePremium: '',
        businessUsePercentage: '',
        stampDuty: 0,
        registration: '',
        gstOnAsset: '',
        gstOnAssetActual: '',
        totalDriveAwayCost: '',
        chanageBudgetsYesNo: '',
        fuelBudget: '',
        serviceBudget: '',
        tyreBudget: '',
        needToCompeteYesNo: '',
        dealerBrokerage: '',
        status: '',
        sortOrder: '',
        has_messages: '',
        messages_for_vsa: '',
        messages_for_other: '',
        privacyConsent: '',
        settlementDate: '',
        fa_no: '',
        edd: ''
      },
      // Client information
      client: {
        title: '',
        gender: '',
        firstName: '',
        middleName: '',
        lastName: '',
        mobileNumber: '',
        email: '',
        grossAnnualSalary: 0,
        payPeriod: '',
        dateOfBirth: '',
        anotherNameYesNo: '',
        otherFirstName: '',
        otherMiddleName: '',
        otherLastName: '',
        driversLicenceNumber: '',
        driversLicenceCardNumber: '',
        driversLicenceExpiryDate: '',
        driversLicenceState: '',
        driversLicenceType: '',
        maritalStatus: '',
        numberOfDependents: '',
        partnerAnnualGrossSalary: '',
        australianResidencyStatusId: '',
        visaTypeId: '',
        citizenOfAnotherCountryYesNo: '',
        citizenOfAnotherCountry: '',
        hAddressUnitNumber: '',
        hAddressStreetNumber: '',
        hAddressStreetName: '',
        hAddressSuburb: '',
        hAddressState: '',
        hAddressPostcode: '',
        hAddressCountry: '',
        hAddressTimeAtYears: 0,
        hAddressTimeAtMonths: '',
        hAddressResidenceStatus: '',
        hAddressMonthlyRentalAmount: '',
        pHAddressUnitNumber: '',
        pHAddressStreetNumber: '',
        pHAddressStreetName: '',
        pHAddressSuburb: '',
        pHAddressState: '',
        pHAddressPostcode: '',
        pHAddressCountry: '',
        pHAddressTimeAtYears: '',
        pHAddressTimeAtMonths: '',
        postalAddressAndHomeAddressAreSameYesNo: '',
        postalAddressPOBoxNumber: '',
        postalAddressSuburb: '',
        postalAddressState: '',
        postalAddressPostcode: '',
        status: 1
      },
      //client_employment_details
      employment: {
        quoteId: '',
        employerName: '',
        tradingName: '',
        ABNOfEmployerOnPayslip: '',
        websiteAddress: '',
        employmentStatus: '',
        occupation: '',
        employerAddressBuildingName: '',
        employerAddressUnitNumber: '',
        employerAddressStreetNumber: '',
        employerAddressStreetName: '',
        employerAddressSuburb: '',
        employerAddressState: '',
        employerAddressPostcode: '',
        employerAddressTimeAtYears: 0,
        employerAddressTimeAtMonths: 0,
        employerContactName: '',
        employerContactNumber: '',
        pEmployerName: '',
        pABNOfEmployerOnPayslip: '',
        pEmploymentStatus: '',
        pOccupation: '',
        pEmployerAddressBuildingName: '',
        pEmployerAddressUnitNumber: '',
        pEmployerAddressStreetNumber: '',
        pEmployerAddressStreetName: '',
        pEmployerAddressSuburb: '',
        pEmployerAddressState: '',
        pEmployerAddressPostcode: '',
        pEmployerAddressTimeAtYears: 0,
        pEmployerAddressTimeAtMonths: 0,
        pEmployerContactName: '',
        pEmployerContactNumber: '',
        investmentIncome: '',
        govConvertibleIncome: '',
        otherIncome: '',
        noteOnOtherIncome: ''
      },
      //client_finance_details
      finance: {
        quoteId: '',
        homePropertyValve: '',
        investmentProperty: [
          {
            value: '',
            limit: '',
            balance: '',
            lenderName: '',
            monthlyPayment: ''
          }
        ],
        vehicleProperty: [
          {
            value: '',
            balance: '',
            lenderName: '',
            monthlyPayment: ''
          }
        ],
        otherMajorVehicles: '',
        superannuationBalance: '',
        toolsAndEquipment: '',
        sharesTrustsSMSF: '',
        cashInTheBank: '',
        homeContents: '',
        otherMajorAsset: '',
        listOtherMajorAsset: '',
        homeLoanBalance: '',
        homeLoanLimit: '',
        homeLoanLenderName: '',
        homeLoanMonthlyPayment: '',
        personalLoan: [
          {
            balance: '',
            lenderName: '',
            monthlyPayment: ''
          }
        ],
        creditCard: [
          {
            limit: '',
            lenderName: ''
          }
        ],
        privateSchoolFees: '',
        vehicleRunningCosts: '',
        livingExpenses: '',
        insurances: '',
        ratesPowerWater: '',
        entertainment: '',
        otherMajorMonthlyExpenses: '',
        totalMonthlyExpenses: ''
      },
      //client_application_notes
      notes: {
        applicationNotes: ''
      },
      //lookup value
      lookupValues: {
        FBTRate: '0',
        GAPInsurance: '0',
        GAPInsuranceVSA: '0',
        GST: '0',
        GSTLimit: '0',
        GSTMaxOnAssets: '0',
        PPSRFee: '0',
        brokerage: '0',
        brokerageVSADefault: '0',
        brokerageVSA: '0',
        id: -1,
        financierId: -1,
        interest: '0',
        leaseAdminFee: '0',
        leaseAdminFeeVSA: '0',
        mcLeaseFee: '0',
        medicare: '0',
        quoteId: -1,
        registration: '0',
        tyreReplaceFreq: '0',
        tyreWheelInsurance: '0'
      },

      optionTitle: optionTitle,
      optionGender: optionGender,
      optionMaritalStatus: optionMaritalStatus,
      anotherNameOptionYesNo: anotherNameOptionYesNo,
      optionCitizenOfAnotherCountryYesNo: optionCitizenOfAnotherCountryYesNo,
      optionPostalAddressAndHomeAddressAreSameYesNo:
        optionPostalAddressAndHomeAddressAreSameYesNo
    }
  },
  computed: {
    ...mapGetters([
      'getSettingAll',
      'getStepNumber',
      'getSaveApplication',
      'getQuoteSingle',
      'getIsLock',
      'getQuoteErrors'
    ]),
    fnChecklessThan3Years: function () {
      let numYears = 0
      let numMonths = 0

      if (this.client.hAddressTimeAtYears) {
        numYears = this.client.hAddressTimeAtYears
      }
      if (this.client.hAddressTimeAtMonths) {
        numMonths = this.client.hAddressTimeAtMonths
      }

      let totalMonths = Number(numYears) * 12 + Number(numMonths)

      return totalMonths
    }
  },
  methods: {
    ...mapActions([
      'fetchStepNumber',
      'fetchQuoteSingle',
      'fetchSaveApplication',
      'fetchQuoteErrors',
      'fetchIsLock'
    ]),

    fnSaveApplication: async function () {
      const allData = {
        quoteType: this.quoteType,
        propsMode: this.propsMode,
        submit_mode: 'save',
        quoteId: this.quoteId,
        vehicle: this.vehicle,
        client: this.client,
        employment: this.employment,
        finance: this.finance,
        lookupValues: this.lookupValues,
        notes: this.notes
      }

      await this.fetchSaveApplication(allData)
      await this.fetchQuoteSingle({
        id: this.quoteId,
        quoteType: this.quoteType
      })
      this.fnCallModalQuoteSubmitConfirm()
    },
    fnTitleChange() {
      if (this.client.title) {
        if (this.client.title == 'Mr') {
          this.client.gender = 'Male'
        } else if (
          this.client.title == 'Mrs' ||
          this.client.title == 'Ms' ||
          this.client.title == 'Miss'
        ) {
          this.client.gender = 'Female'
        }
      }
    },
    fnReplace(str) {
      const newString = str.toString().replace('[', '').replace(']', '')

      return newString
    },
    /**
     * To Show Unlock button
     */
    fnIsShowUnlockButton() {
      let status = false

      if (this.propsMode == 'edit') {
        if (
          this.propsData.status != 1 &&
          this.propsData.status != 7 &&
          this.propsData.status != 8 &&
          this.quoteType == 'quote'
        ) {
          status = true
        }

        if (
          this.propsData.status != 21 &&
          this.propsData.status != 22 &&
          this.propsData.status != 24 &&
          this.propsData.status != 25 &&
          this.propsData.status != 26 &&
          this.quoteType == 'leads'
        ) {
          status = true
        }
      }

      return status
    },

    fnCheckIsLocked(status) {
      if (
        status == 2 ||
        status == 3 ||
        status == 4 ||
        status == 5 ||
        status == 6 ||
        status == 9 ||
        status == 10 ||
        status == 11 ||
        status == 12 ||
        status == 13 ||
        status == 14 ||
        status == 23
      ) {
        this.fetchIsLock(true)
      } else {
        console.log('step2-false')
        this.fetchIsLock(false)
      }
    },
    /**
     * Call Modal which is used to update quote status
     * if quote status in 13 or 14 into 3
     */
    fnCallModalQuoteSubmitConfirm() {
      if (this.vehicle.status == 13 || this.vehicle.status == 14) {
        const childComponent = this.$refs.modalQuoteSubmitConfirm
        if (childComponent) {
          childComponent.fnModalShow()
        }
      }
    }
  },
  watch: {
    propsData(newValue) {
      this.vehicle.clientId = newValue.clientId
      this.vehicle.dealerId = newValue.dealerId
      this.vehicle.referralPartnerId = newValue.referralPartnerId
      this.vehicle.referDealerId = newValue.referDealerId
      this.vehicle.leadSource = newValue.leadSource
      this.vehicle.salaryPackagingProviderId =
        newValue.salaryPackagingProviderId
      this.vehicle.salaryPackagingProviderFee =
        newValue.salaryPackagingProviderFee
      this.vehicle.vehicleCondition = newValue.vehicleCondition
      this.vehicle.odometerReading = newValue.odometerReading
      this.vehicle.year = newValue.year
      this.vehicle.make = newValue.make
      this.vehicle.model = newValue.model
      this.vehicle.variant = newValue.variant
      this.vehicle.bodyType = newValue.bodyType
      this.vehicle.vehicleCategoryId = newValue.vehicleCategoryId
      this.vehicle.fuelFlatRate = newValue.fuelFlatRate
      this.vehicle.fuelCostPerKM = newValue.fuelCostPerKM
      this.vehicle.tyresCostPerKM = newValue.tyresCostPerKM
      this.vehicle.serviceCostPerKM = newValue.serviceCostPerKM
      this.vehicle.transmissionId = newValue.transmissionId
      this.vehicle.fuelTypeId = newValue.fuelTypeId
      this.vehicle.colour = newValue.colour
      this.vehicle.accessories = newValue.accessories
      this.vehicle.term = newValue.term
      this.vehicle.rvRate = newValue.rvRate
      this.vehicle.annualKms = newValue.annualKms
      this.vehicle.noFinanceInsurance = newValue.noFinanceInsurance
      this.vehicle.comprehensiveInsurer = newValue.comprehensiveInsurer
      this.vehicle.comprehensiveInsurancePremium =
        newValue.comprehensiveInsurancePremium
      this.vehicle.businessUsePercentage = newValue.businessUsePercentage
      this.vehicle.stampDuty = newValue.stampDuty
      this.vehicle.registration = newValue.registration
      this.vehicle.gstOnAsset = newValue.gstOnAsset
      this.vehicle.gstOnAssetActual = newValue.gstOnAssetActual
      this.vehicle.totalDriveAwayCost = newValue.totalDriveAwayCost
      this.vehicle.chanageBudgetsYesNo = newValue.chanageBudgetsYesNo
      this.vehicle.fuelBudget = newValue.fuelBudget
      this.vehicle.serviceBudget = newValue.serviceBudget
      this.vehicle.tyreBudget = newValue.tyreBudget
      this.vehicle.needToCompeteYesNo = newValue.needToCompeteYesNo
      this.vehicle.dealerBrokerage = newValue.dealerBrokerage
      this.vehicle.status = newValue.status
      this.vehicle.sortOrder = newValue.sortOrder
      this.vehicle.has_messages = newValue.has_messages
      this.vehicle.messages_for_vsa = newValue.messages_for_vsa
      this.vehicle.messages_for_other = newValue.messages_for_other
      this.vehicle.privacyConsent = newValue.privacyConsent
      this.vehicle.settlementDate = newValue.settlementDate
      this.vehicle.fa_no = newValue.fa_no
      this.vehicle.edd = newValue.edd

      Object.assign(this.client, newValue.client)
      Object.assign(this.employment, newValue.client_employment_detail)
      Object.assign(this.finance, newValue.client_finance_detail)
      Object.assign(this.notes, newValue.client_application_notes)
      Object.assign(this.lookupValues, newValue.client_lookup_values)
      this.fnCheckIsLocked(newValue.status)
    }
  }
}
</script>
